import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Download, FileText } from "lucide-react";
import { documentUrl } from "@/lib/api";
import { isImage, isPdf, formatBytes } from "@/lib/constants";

export const DocumentViewer = ({ open, onOpenChange, clientId, doc }) => {
  if (!doc) return null;
  const url = documentUrl(clientId, doc.id);
  const viewable = isImage(doc.content_type) || isPdf(doc.content_type);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl p-0 gap-0" data-testid="document-viewer-modal">
        <DialogHeader className="px-6 py-4 border-b border-slate-100">
          <DialogTitle className="font-heading text-lg flex items-center gap-2 pr-8">
            <FileText className="h-5 w-5 text-slate-500" />
            <span className="truncate">{doc.filename}</span>
          </DialogTitle>
        </DialogHeader>

        <div className="bg-slate-50 min-h-[60vh] max-h-[70vh] flex items-center justify-center overflow-auto p-4">
          {isImage(doc.content_type) ? (
            <img src={url} alt={doc.filename} className="max-w-full max-h-[65vh] rounded-md shadow" />
          ) : isPdf(doc.content_type) ? (
            <iframe src={url} title={doc.filename} className="w-full h-[65vh] rounded-md border-0" />
          ) : (
            <div className="text-center space-y-4 py-12">
              <FileText className="h-16 w-16 text-slate-300 mx-auto" />
              <div>
                <p className="text-slate-700 font-medium">{doc.filename}</p>
                <p className="text-sm text-slate-500">
                  {formatBytes(doc.size)} · Vista previa no disponible para este formato
                </p>
              </div>
            </div>
          )}
        </div>

        <div className="px-6 py-4 border-t border-slate-100 flex justify-end gap-2">
          {!viewable && (
            <span className="text-sm text-slate-400 self-center mr-auto">
              Descarga el archivo para abrirlo.
            </span>
          )}
          <Button asChild variant="outline" data-testid="download-document-button">
            <a href={documentUrl(clientId, doc.id, true)}>
              <Download className="h-4 w-4 mr-2" /> Descargar
            </a>
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
